import envConfig from './config.preview';

const config = {
  ...envConfig,

  // 1 day
  authWebExpiryInSeconds: 86400,

  cookies: {
    authLoggedInUser: 'ac-auth-logged-in-user',
  },
  limit: {
    default: 100,
    bookings: 10,
    routes: 100,
    virtuals: 100,
    providers: 100,
  },
};

export default config;
